import React from 'react'
import styles from './style.module.scss'
import helmet from '@assets/images/f1/icons/helmet.png'
import Image from 'next/future/image'
import btn from '@assets/images/f1/icons/outline.png'
import F1Heading from '../F1Heading'
import PropTypes from 'prop-types'
import { getImgURL } from '@shared-submodule/utils'
import CustomLink from '@shared/components/customLink'

function NewsForYou({ editorsList }) {
  return (
    <>
      <div className={`${styles.newForYou} container`}>
        <div className={styles.headSpace}>
          <F1Heading title={'News For You'} />
        </div>
        <div className={styles.newsCarousel}>
          {editorsList?.map((info, i) => {
            return (
              <CustomLink href={info?.oSeo?.sSlug} key={i}>
                <a>
                  <div
                    className={styles.newsContainer}
                    style={{ backgroundImage: `url(${getImgURL(info?.oImg?.sUrl)})`, backgroundSize: 'cover' }}>
                    <div className={styles.news}>
                      <h3 className={styles.title}>{info?.sTitle}</h3>
                      <div className={styles.author}>
                        <p className={styles.desc}>{info?.sSubtitle}</p>
                        <div className={styles.line}></div>
                        <div className={styles.source}>
                          <div className="d-flex flex-row align-items-center">
                            <Image
                              src={info?.authorImg || helmet}
                              alt={info?.oDisplayAuthor?.sFName}
                              width={40}
                              height={40}
                              className={styles.img}
                            />
                            <span className={styles.name}>{info?.oDisplayAuthor?.sFName}</span>
                          </div>
                          <div className="d-flex flex-row align-items-center">
                            <span className={styles.readMore}>READ MORE</span>
                            <Image src={btn} alt="Read More button" width={40} height={40} className={styles.img} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </CustomLink>
            )
          })}
        </div>
      </div>
    </>
  )
}

NewsForYou.propTypes = {
  editorsList: PropTypes.array
}

export default NewsForYou
